import {$, w} from './constants';
import './tabs.js';
import './gtm.js';
import './utm.js';
import { sliderGrab } from './sliders.js';
import './form.js';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    igualarAlturasTipos();
	sliderGrab();
})

$(w).on('resize', function(){
    requestAnimationFrame(() => {
        igualarAlturasTipos();
    });
})

/* C a r d s  M o d a l i d a d */
function igualarAlturasTipos() {
    const $blocks = $('#blocks_type');
	if (!$blocks.length) return; 
    
	const clases = ['.upper-container'];

	if (window.innerWidth <= 950){
        clases.forEach(function(clase) {
            $('.home-template__types-block ' + clase).css('height', 'auto');
        });
        return;
    }
	clases.forEach(function(clase) {
		// Reinicia alturas
		$('.home-template__types-block ' + clase).css('height', 'auto');

		// Agrupar en pares (2 columnas por fila)
		let items = $('.home-template__types-block');
		for (let i = 0; i < items.length; i += 2) {
			let $rowItems = items.slice(i, i + 2); // grupo de A-B, C-D, etc.
			let maxHeight = 0;

			$rowItems.find(clase).each(function() {
				let altura = $(this).outerHeight();
				if (altura > maxHeight) maxHeight = altura;
			});

			$rowItems.find(clase).height(maxHeight);
		}
	});
}

//Scroll en links de misma página
$('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on('click', function (event) {

        if ($(this).closest('#menu_home_sections').length) return;

        const url = new URL(this.href, window.location.origin);

        const samePage =
            url.origin === window.location.origin &&
            url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');

        if (!samePage) return;

        const hash = url.hash;

        if (!hash) return;

        let target = $(hash);
        target = target.length ? target : $('[name="' + hash.slice(1) + '"]');

        if (!target.length) return;

        event.preventDefault();

        $('html, body').animate({
            scrollTop: target.offset().top - 140
        }, 1000);
    });